module.exports = "/_next/static/images/ilustrasi-hubungi-kami-dcb6fc48ed03b6eec2a4a885c28a1b42.png";